export default {
  'price.title': 'Price',
  'price.originalPrice': 'Original Price',
  'price.currency': 'Currency',
  'price.originalPriceError': 'Original Price is required',
  'price.discountedPrice': 'Discounted Price',
  'price.discountBy': 'Discount By',
  'price.discountedCalc': 'Will be Calculated',
  'price.discounted': 'Is Discounted?',
  'price.trialed': 'Is Trialed?',
  'price.duration': 'Payment Duration',
  'price.durationPeriod': 'Period',
  'price.discount': 'Payment Discount',
  'price.trialedDiscount': 'Trial Period Discount',
  'price.discountInfo': '{{header}} Discount Info',
  'price.discountStartedAt': 'Started at',
  'price.discountDuration': 'Discount Duration',
  'price.trial': 'Trial',
  'price.sale': 'Sale',
  'price.saleAt': 'Sale Started / Expired (at)',
  'price.trialDuration': 'Trial Period Duration',
  'price.trialPriceInfo': 'Trial Period',
  'price.priceInfo': '{{type}} Price Info',
  'price.info.helper':
    'Set the original price, select currency, apply discounts, and define trial details',
};
